module.exports = __webpack_public_path__ + "media/flags/mf-b2f9987d.svg";